/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const bowling_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.25 8.25V3a2.25 2.25 0 1 0-4.5 0v5.25m4.5 0a11.476 11.476 0 0 1 3 7.5 11.418 11.418 0 0 1-2.509 6.933 1.499 1.499 0 0 1-1.175.567H4.434a1.5 1.5 0 0 1-1.175-.567A11.418 11.418 0 0 1 .75 15.75a11.476 11.476 0 0 1 3-7.5m4.5 0h-4.5m8.711 14.242a7.5 7.5 0 1 0 0-13.486M8.25 5.25h-4.5m12.094 10.253h.803m2.962-.753h.803m-3.82-2.984h.803m-.653 3.737a.48.48 0 0 1-.502.498.479.479 0 0 1-.498-.498.48.48 0 0 1 .498-.502.48.48 0 0 1 .502.502Zm3.765-.753a.48.48 0 0 1-.502.498.479.479 0 0 1-.498-.498.48.48 0 0 1 .498-.502.48.48 0 0 1 .502.502Zm-3.017-2.984a.48.48 0 0 1-.502.498.479.479 0 0 1-.498-.498.48.48 0 0 1 .498-.502.48.48 0 0 1 .502.502Z"
    />
  </svg>
)
export default bowling_medium
